import I18n from 'I18n';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import ObjectTypeName from 'marketing-platform-lib/CRM/ObjectTypeName';
import { getPropertyValue } from 'framework-asset-preview-lib/internal/shared/utils/crmObject';
import { fetchWorkflowPerformance } from './api';
import { jsx as _jsx } from "react/jsx-runtime";
export function getNonCrmPropertyValue(propertyName, nonCrmObject) {
  if (!nonCrmObject) {
    return undefined;
  }
  const workflowResponse = nonCrmObject;
  switch (propertyName) {
    default:
      return undefined;
    case 'enrolledLastWeek':
      return workflowResponse.enrolledLastWeek || 0;
    case 'currentlyEnrolled':
      return workflowResponse.currentlyEnrolled || 0;
    case 'currentlyEnrolledAndDelayed':
      return workflowResponse.currentlyEnrolledAndDelayed || 0;
  }
}
export function getWorkflowPerformanceStats({
  crmObject,
  nonCrmObject
}) {
  return fetchWorkflowPerformance(crmObject).then(workflowPerformanceResponse => {
    const performanceResponse = workflowPerformanceResponse.length ? workflowPerformanceResponse[0] : {
      breakdown: '',
      counterValues: {
        currently_enrolled: {
          value: 0
        },
        enrollments: {
          value: 0
        },
        unenrollments: {
          value: 0
        },
        unique_enrollments: {
          value: 0
        }
      }
    };
    const hsObjectTypeId = getPropertyValue(crmObject, 'hs_object_type_id', '0-1');
    const overviewPerfGroup = {
      stats: [{
        formatStyle: 'text',
        label: /*#__PURE__*/_jsx(FormattedJSXMessage, {
          elements: {
            ObjectTypeName
          },
          message: "frameworkAssetPreviewLib.propertyLabel.0-44.hs_automation_flow_total_unique_enrolled_jsx",
          options: {
            form: 'plural',
            objectTypeId: `${hsObjectTypeId}`,
            textTransform: 'lowercase'
          }
        }),
        propertyName: 'hs_automation_flow_total_unique_enrolled',
        value: performanceResponse.counterValues.unique_enrollments.value
      }, {
        formatStyle: 'text',
        label: /*#__PURE__*/_jsx(FormattedJSXMessage, {
          elements: {
            ObjectTypeName
          },
          message: "frameworkAssetPreviewLib.propertyLabel.0-44.hs_automation_flow_total_enrolled_jsx",
          options: {
            form: 'plural',
            objectTypeId: `${hsObjectTypeId}`,
            textTransform: 'lowercase'
          }
        }),
        propertyName: 'hs_total_enrolled',
        value: String(getPropertyValue(crmObject, 'hs_total_enrolled', '0'))
      }, {
        formatStyle: 'text',
        label: I18n.text('frameworkAssetPreviewLib.propertyLabel.0-44.hs_automation_flow_total_enrolled_last_week'),
        propertyName: 'enrolledLastWeek',
        value: getNonCrmPropertyValue('enrolledLastWeek', nonCrmObject)
      }, {
        formatStyle: 'text',
        label: /*#__PURE__*/_jsx(FormattedJSXMessage, {
          elements: {
            ObjectTypeName
          },
          message: "frameworkAssetPreviewLib.propertyLabel.0-44.hs_automation_flow_total_currently_enrolled_and_delayed_jsx",
          options: {
            form: 'plural',
            objectTypeId: `${hsObjectTypeId}`
          }
        }),
        propertyName: 'currentlyEnrolledAndDelayed',
        value: getNonCrmPropertyValue('currentlyEnrolledAndDelayed', nonCrmObject)
      }],
      title: I18n.text('frameworkAssetPreviewLib.tabs.performance.performanceGroup.0-44.overview')
    };
    return [overviewPerfGroup];
  });
}